// extracted by mini-css-extract-plugin
export var cardIcon = "_72-5";
export var cardIconUnframed = "_72-9";
export var checkboxCard = "_72-0";
export var checkboxCardSelected = "_72-4";
export var disabled = "_72-2";
export var interactive = "_72-1";
export var outerBorder = "_72-3";
export var spacerMedium = "_72-8";
export var spacerSmall = "_72-7";
export var spacerXsmall = "_72-6";